import * as React from "react";
import NewsletterSignup from "@/ReactComponents/Newsletter_OLD/newsletter-signup-banner";

const NewsletterSignupView = props => <NewsletterSignup {...props} />;

export default NewsletterSignupView;
